import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { classTypeToUrlSlugResolver } from "~/utils/classTypeToUrlSlugResolver";
import { fetch } from "~/utils/fetch";

export const useRestoreFromArchiveMutation = (object_class, object_id) => {
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/restore-from-archive/${classTypeToUrlSlugResolver(object_class)}/${object_id}`,
        method: "PUT",
      }),
  });
};
